/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { IoIosArrowDown, IoMdArrowDropdown, IoMdPerson } from 'react-icons/io';
import Popup from 'reactjs-popup';
import { useCookies } from 'react-cookie';
import logoStone from '../../assets/icons/logo-stone.svg';
import {
  Content,
  Menu,
  Left,
  Banner,
  Right,
  LogOut,
  List,
  NavMenu,
} from './styles';
import Tooltip from '../Tooltip';

const HeaderFull: React.FC = () => {
  const [cookies] = useCookies(['stone-codes']);
  const stoneCode = cookies.external_stone_codes;
  return (
    <Content>
      <Menu>
        <Left>
          <a href={`${process.env.REACT_APP_API_ENDPOINT}`}>
            <Banner>
              <img src={logoStone} alt="Stone Logo" />
            </Banner>
          </a>
          <NavMenu>
            <label hidden={!cookies.external_stone_codes}>
              <a href={`${process.env.REACT_APP_API_ENDPOINT}/resumo`}>
                Início
              </a>
            </label>
            <label hidden={!cookies.external_stone_codes}>
              <a
                href={`${process.env.REACT_APP_API_ENDPOINT}/vendas/transacoes`}
              >
                Vendas
              </a>
            </label>
            <label
              hidden={
                !!cookies.external_tags
                  ? !cookies.external_tags.gps_recebedor
                  : true
              }
            >
              <a href={`${process.env.REACT_APP_API_ENDPOINT}/conta`}>Conta</a>
            </label>
            <label hidden={!cookies.external_stone_codes}>
              <Popup
                className="pagamentos"
                trigger={
                  <a
                    href={`${process.env.REACT_APP_API_ENDPOINT}/extratos/meus-ganhos/calendario`}
                  >
                    <label>
                      Pagamentos <IoMdArrowDropdown />
                    </label>
                  </a>
                }
                position="bottom left"
                on="hover"
              >
                <List>
                  <a
                    href={`${process.env.REACT_APP_API_ENDPOINT}/extratos/meus-ganhos/calendario`}
                  >
                    Calendário
                  </a>
                  <a
                    href={`${process.env.REACT_APP_API_ENDPOINT}/extratos/meus-ganhos/periodo`}
                  >
                    Pagamentos por período
                  </a>
                </List>
              </Popup>
            </label>
            <label
              hidden={
                !(
                  !cookies.external_stone_codes &&
                  (cookies.external_permission_collection
                    ? !cookies.external_permission_collection.PREPAY_PAYMENT
                    : true)
                )
              }
            >
              <a href={`${process.env.REACT_APP_API_ENDPOINT}/rav`}>
                Antecipação
              </a>
            </label>
            <label
              hidden={
                !(
                  !cookies.external_stone_codes &&
                  (cookies.external_permission_collection
                    ? !cookies.external_permission_collection.REQUEST_CREDIT
                    : true)
                )
              }
            >
              <Popup
                className="pagamentos"
                trigger={
                  <label>
                    Financeiro <IoMdArrowDropdown />
                  </label>
                }
                position="bottom left"
                on="hover"
              >
                <List>
                  <label
                    hidden={
                      cookies.external_permission_collection
                        ? !cookies.external_permission_collection.PREPAY_PAYMENT
                        : true
                    }
                  >
                    <a href={`${process.env.REACT_APP_API_ENDPOINT}/rav`}>
                      Antecipação
                    </a>
                  </label>
                  <a
                    href="https://emprestimo.portal.stone.com.br"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Empréstimo
                  </a>
                </List>
              </Popup>
            </label>
            <label
              hidden={
                !!cookies.external_tags
                  ? !cookies.external_tags.gps_recebedor
                  : true
              }
            >
              <Popup
                className="pagamentos"
                trigger={
                  <label>
                    GPS <IoMdArrowDropdown />
                  </label>
                }
                position="bottom left"
                on="hover"
              >
                <List>
                  <a
                    href={`${process.env.REACT_APP_API_ENDPOINT}/gps/conciliacao/pagamentos`}
                  >
                    Pagamentos
                  </a>
                  <a
                    href={`${process.env.REACT_APP_API_ENDPOINT}/gps/conciliacao/vendas`}
                  >
                    Vendas
                  </a>
                  <a href={`${process.env.REACT_APP_GPS_ENDPOINT}`}>
                    Gestão de Propostas
                  </a>
                </List>
              </Popup>
            </label>
            <Popup
              className="pagamentos"
              trigger={
                <label>
                  Serviços <IoMdArrowDropdown />
                </label>
              }
              position="bottom left"
              on="hover"
            >
              <List>
                <a
                  href={`${process.env.REACT_APP_API_ENDPOINT}/gerenciamento-de-bandeiras`}
                >
                  Gerenciar Bandeiras
                </a>
                <label
                  hidden={
                    cookies.external_permission_collection
                      ? !cookies.external_permission_collection
                          .REQUEST_PAPER_ROLL
                      : true
                  }
                >
                  <a href={`${process.env.REACT_APP_API_ENDPOINT}/servicos`}>
                    Pedir bobinas
                  </a>
                </label>
                <label
                  hidden={
                    cookies.external_permission_collection
                      ? !cookies.external_permission_collection
                          .REQUEST_EQUIPAMENT_INSTALLATION
                      : true
                  }
                >
                  <a href={`${process.env.REACT_APP_API_ENDPOINT}/servicos`}>
                    Solicitar equipamento
                  </a>
                </label>
                <a href={`${process.env.REACT_APP_API_ENDPOINT}/servicos`}>
                  Baixar DIRF
                </a>
              </List>
            </Popup>
            {/* <label hidden={cookies.external_permission_collection ? !cookies.external_stone_codes && !cookies.external_permission_collection.PREPAY_PAYMENT : true} >
              <a href="/">
                Produtos
            </a>
            </label> */}
          </NavMenu>
        </Left>
        <Right>
          <Popup
            className="user"
            trigger={
              <LogOut>
                <label>
                  <span>{stoneCode}</span>
                  <IoIosArrowDown className="webIcon" />
                  <IoMdPerson className="mobileIcon" />
                </label>
              </LogOut>
            }
            position="bottom right"
            on="hover"
          >
            <Tooltip />
          </Popup>
        </Right>
      </Menu>
    </Content>
  );
};

export default HeaderFull;
